export const brandsDE = ["mc", "visa", "amex"]

export const adyenCheckoutConfiguration = {
  locale: process.env.GATSBY_I18N_LOCALE,
  clientKey: process.env.GATSBY_ADYEN_CLIENT_KEY,
  environment: process.env.GATSBY_ADYEN_ENVIRONMENT,
  showPayButton: true,
  paymentMethodsResponse: {
    paymentMethods: [
      {
        type: "applepay",
        configuration: {
          merchantId: process.env.GATSBY_ADYEN_MERCHANT_ID,
          merchantName: process.env.GATSBY_ADYEN_MERCHANT_NAME,
        },
      },
    ],
  },
  paymentMethodsConfiguration: {
    card: {
      hasHolderName: true,
      holderNameRequired: true,
      setStatusAutomatically: true,
      showBrandsUnderCardNumber: false,
      // enableStoreDetails: true,
    },
  },
}
